export const calculateHeight = (rowCount: number, customRowHeight?: number): number => {

  if (rowCount > 5) {
    return undefined;
  }

  const rowHeight = customRowHeight ?? 45;
  const extraHeight = 30;

  return rowHeight*rowCount+extraHeight;
};
